import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { GstSummary } from "@/components/gst/GstSummary";
import { GstBills } from "@/components/gst/GstBills";
import { GstCalendar } from "@/components/gst/GstCalendar";
import { api, errMsg } from "@/lib/api";
import { todayIST } from "@/lib/format";

export default function Gst() {
  const [month, setMonth] = useState(todayIST().slice(0, 7));
  const [sum, setSum] = useState(null);
  const [bills, setBills] = useState([]);
  const load = useCallback(() => {
    api.get("/gst/summary", { params: { month } }).then((r) => setSum(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get("/gst/bills", { params: { month } }).then((r) => setBills(r.data)).catch(() => {});
  }, [month]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="gst-page">
      <PageHeader eyebrow="Tax" title="GST" subtitle="Output GST on your sales, input tax credit from grocery GST bills, and the monthly figures your accountant files.">
        <Input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className="w-44" data-testid="gst-month" />
      </PageHeader>
      <GstCalendar />
      <Tabs defaultValue="summary">
        <TabsList className="mb-4"><TabsTrigger value="summary" data-testid="gst-tab-summary">Monthly summary</TabsTrigger><TabsTrigger value="bills" data-testid="gst-tab-bills">Purchase bills ({bills.length})</TabsTrigger></TabsList>
        <TabsContent value="summary">{sum && <GstSummary s={sum} />}</TabsContent>
        <TabsContent value="bills"><GstBills bills={bills} month={month} reload={load} /></TabsContent>
      </Tabs>
    </div>
  );
}
